import React, {ReactNode} from "react";
import sf from "../../images/hl3.jpg";
import {Link} from "react-router-dom";
import Loading from "../../components/loading";
import { CoursesData } from "../types";

const CourseItem:React.FC<CoursesData> = ( props ) => {
    return <Link className='course-item' to={`/course/${ props.id }/detail`}>
        <div className="img-box">
            <div className="bg" style={{backgroundImage: `url(${ props.coverUrl })`}}/>
        </div>
        <div className="text">
            <h3>{ props.courseName }</h3>
            <p className="des">
                {
                    props.courseSummary
                }
            </p>
            {
               <props.render {...props}/>
            }

        </div>
    </Link>
}

interface CourseList {
    list: Array<CoursesData>,
    render: ReactNode,
    loading?: boolean
}

const CourseLayOut: React.FC<CourseList> = ({list, render, loading = false}) => {

    // console.log(render)

    return <div className="course-list">
        {
            list.map((item, index) => {
                return <CourseItem {...item} key={index} render={ render }/>
            })
        }
        <Loading show={loading}/>

    </div>
}

export default CourseLayOut;
